import { useCallback, useEffect, useState } from "react";
import { Breadcrumb, Button, Col, Container, Row } from "react-bootstrap";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";

import Daily from "./Daily";
import Monthly from "./Monthly";
import Weekly from "./Weekly";
import Yearly from "./Yearly";

import ContentWrapper, {
    SimpleModalDataType,
} from "components/content-wrapper/ContentWrapper";
import DefaultModal, { useModal } from "components/modals/ModalTemplate";
import {
    DAILY,
    DATE_TIME_FORMATS,
    DaysOfWeek,
    ERROR_BEFORE_OR_AFTER,
    ERROR_EMPTY,
    ERROR_INCORRECT_VALUE,
    ERROR_INVALID,
    ERROR_INVALID_BEFORE_AFTER_DATE,
    ERROR_INVALID_DATE,
    ERROR_NOT_POSITIVE_INTEGER,
    ERROR_NO_DURATION,
    ERROR_NO_INTERVAL,
    ERROR_RECURRENCE_WEEKLY_DAY,
    MONTHLY,
    MonthsMap,
    RECURRENCE_DATE_TIME_FORMAT,
    START_OF_DAY_AT_FIRST_MINUTE,
    TimeSchedule,
    WEEKLY,
    YEARLY,
} from "constant";
import { isEmpty } from "lodash";
import moment, { Moment } from "moment-timezone";
import EventService from "service/eventService";

import "assets/css/event.css";
import { useOrganisation } from "hooks/organization";
import { getDefaultRecurrenceEndTime } from "utils/eventFunctions";
import { getLocalTimezone, isHttpSuccess } from "utils/functions";
import RepeatInterval, {
    RepeatIntervalValue,
} from "./components/RepeatInterval";
import RepeatOption from "./components/RepeatOption";
interface StartTime {
    default: Moment;
    sunday: Moment;
    monday: Moment;
    tuesday: Moment;
    wednesday: Moment;
    thursday: Moment;
    friday: Moment;
    saturday: Moment;
}
interface TimeArray {
    [key: string]: Array<string>;
}

const { LONG_TIME_24H } = DATE_TIME_FORMATS;

const Recurrence = () => {
    const params: any = useParams();
    const history: any = useHistory();
    const location: any = useLocation();
    const { defaultTimeZone } = useOrganisation();

    const selectedOperator = location?.state?.selectedOperator;
    const slotCount = location?.state?.slotCount;
    const selectedSlotIndex = location?.state?.selectedSlotIndex;

    const [modalShow, setModalShow] = useState(false);
    const [modalType, setModalType] = useState("");
    const [modalContent, setModalContent] = useState("");
    const [errorArray, setErrorArray]: any = useState([]);
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [invalidBeforeAfterDateMsg, setInvalidBeforeAfterDateMsg] =
        useState("");

    // IN CURRENT COMPONENT
    const [selectedRepeatOption, setSelectedRepeatOption] = useState(DAILY);
    const [currentRecurrenceDetail, setCurrentRecurrenceDetail]: any = useState(
        {}
    );

    const [repeatIntervalVal, setRepeatIntervalVal] = useState<
        Record<string, RepeatIntervalValue>
    >({
        [DAILY]: {
            value: "1",
            errorMessage: "",
        },
        [WEEKLY]: {
            value: "1",
            errorMessage: "",
        },
        [MONTHLY]: {
            value: "1",
            errorMessage: "",
        },
        [YEARLY]: {
            value: "1",
            errorMessage: "",
        },
    });

    // FOR DAILY AND WEEKLY
    const [selectedTimeOption, setSelectedTimeOption]: any = useState({
        default: TimeSchedule.ALL_DAY,
        sunday: TimeSchedule.ALL_DAY,
        monday: TimeSchedule.ALL_DAY,
        tuesday: TimeSchedule.ALL_DAY,
        wednesday: TimeSchedule.ALL_DAY,
        thursday: TimeSchedule.ALL_DAY,
        friday: TimeSchedule.ALL_DAY,
        saturday: TimeSchedule.ALL_DAY,
    });

    const defaultStartTime: StartTime = {
        default: START_OF_DAY_AT_FIRST_MINUTE,
        sunday: START_OF_DAY_AT_FIRST_MINUTE,
        monday: START_OF_DAY_AT_FIRST_MINUTE,
        tuesday: START_OF_DAY_AT_FIRST_MINUTE,
        wednesday: START_OF_DAY_AT_FIRST_MINUTE,
        thursday: START_OF_DAY_AT_FIRST_MINUTE,
        friday: START_OF_DAY_AT_FIRST_MINUTE,
        saturday: START_OF_DAY_AT_FIRST_MINUTE,
    };

    const [priTime, setPriTime] = useState<any>(defaultStartTime);

    const [secTime, setSecTime] = useState<any>(defaultStartTime);

    const [selectedInterval, setSelectedInterval]: any = useState({
        default: "hours",
        sunday: "hours",
        monday: "hours",
        tuesday: "hours",
        wednesday: "hours",
        thursday: "hours",
        friday: "hours",
        saturday: "hours",
    });

    const [duration, setDuration]: any = useState({
        default: "",
        sunday: "",
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
    });

    const defaultTimeArray: TimeArray = {
        default: [],
        sunday: [],
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
    };

    const [timeList, setTimeList] = useState<TimeArray>(defaultTimeArray);
    const [timeRangeList, setTimeRangeList] =
        useState<TimeArray>(defaultTimeArray);

    const [errorType, setErrorType]: any = useState({
        day: "",
        errorType: "",
    });
    const [simpleModalData, setSimpleModalData] =
        useState<null | SimpleModalDataType>(null);
    const [checkboxState, setCheckboxState]: any = useState({
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
    });

    const [error, setError]: any = useState({
        component: "",
        errorType: "",
        day: "",
        month: "",
    });
    const [recurrenceErrorMsg, setRecurrenceErrorMsg] = useState("");

    // FOR MONTHLY AND YEARLY
    const [allDates, setAllDates]: any = useState([]);

    const defaultRecurrenceStartTime = moment();

    // RANGE OF RECURRENCE
    const [recurrenceRange, setRecurrenceRange] = useState<any>({
        daily: {
            startDate: defaultRecurrenceStartTime,
            endDate: getDefaultRecurrenceEndTime({
                startTime: defaultRecurrenceStartTime,
                amount: 1,
                unit: "months",
            }),
            endDateEnabled: false,
        },
        weekly: {
            startDate: defaultRecurrenceStartTime,
            endDate: getDefaultRecurrenceEndTime({
                startTime: defaultRecurrenceStartTime,
                amount: 3,
                unit: "months",
            }),
            endDateEnabled: false,
        },
        monthly: {
            startDate: defaultRecurrenceStartTime,
            endDate: getDefaultRecurrenceEndTime({
                startTime: defaultRecurrenceStartTime,
                amount: 1,
                unit: "years",
            }),
            endDateEnabled: false,
        },
        yearly: {
            startDate: defaultRecurrenceStartTime,
            endDate: getDefaultRecurrenceEndTime({
                startTime: defaultRecurrenceStartTime,
                amount: 5,
                unit: "years",
            }),
            endDateEnabled: false,
        },
    });

    const { openModal, modal } = useModal();

    const backToEventPage = useCallback(() => {
        history.push(`/event-details/${params.eventId}`);
    }, [params.eventId, history]);

    // PROPS TO PASS TO CHILDREN
    const updatePriTime = (priTime: any) => {
        setPriTime(priTime);
    };

    const updateSecTime = (secTime: any) => {
        setSecTime(secTime);
    };

    const updateSelectedTimeOption = (selectedTimeOption: any) => {
        setError({});
        setErrorType({});
        setSelectedTimeOption(selectedTimeOption);
    };

    const updateDuration = (duration: any) => {
        setDuration(duration);
    };

    const updateSelectedInterval = (interval: any) => {
        setSelectedInterval(interval);
    };

    const updateTimeList = (timeList: any) => {
        setTimeList(timeList);
    };

    const updateTimeRangeList = (timeRangeList: any) => {
        setTimeRangeList(timeRangeList);
    };

    const updateErrorType = (errorType: any) => {
        setErrorType(errorType);
    };

    const updateCheckboxState = (newCheckboxState: any) => {
        setCheckboxState(newCheckboxState);
    };

    const updateAllDates = (allDates: any) => {
        setAllDates(allDates);
    };

    const updateRecurrenceRange = (recurrenceRange: any) => {
        setRecurrenceRange(recurrenceRange);
    };

    const updateRecurrenceErrorMsg = useCallback(
        (recurrenceErrorMsg: string) => {
            setRecurrenceErrorMsg(recurrenceErrorMsg);
        },
        []
    );

    const clearParentError = useCallback(() => {
        setError({});
    }, []);

    useEffect(() => {
        moment.tz.setDefault(defaultTimeZone);
        return () => {
            moment.tz.setDefault(getLocalTimezone());
        };
    }, [defaultTimeZone]);

    useEffect(() => {
        if (params.conditionId) {
            const fetchCondition = async () => {
                const response = await EventService.readOneCondition(
                    params.conditionId,
                    params.eventId
                );

                const {
                    resource: {
                        date2: {
                            repeat = "",
                            interval = 0,
                            daily: {
                                ranges = [],
                                points = [],
                                schedule = "",
                                interval: daily_time_schedule_interval = 0,
                            } = {},
                            weekly: { weekdays = {} } = {},
                            monthly = {},
                            yearly = {},
                        } = {},
                    } = {},
                } = response.data || {};

                if (isHttpSuccess(response.status)) {
                    // Set Current Slot
                    setCurrentRecurrenceDetail(response.data);
                    // Set operator (daily, weekly, monthly ...)
                    setSelectedRepeatOption(repeat);

                    // Depending on operator ( Set repeated interval and time schedule)

                    setRepeatIntervalVal({
                        ...repeatIntervalVal,
                        [repeat]: {
                            value: interval,
                            errorMessage: "",
                        },
                    });
                    switch (repeat) {
                        case DAILY: {
                            setSelectedTimeOption({
                                ...selectedTimeOption,
                                default: schedule,
                            });

                            switch (schedule) {
                                case TimeSchedule.BEFORE:
                                    setPriTime({
                                        ...defaultStartTime,
                                        default: moment(
                                            ranges[0][1],
                                            LONG_TIME_24H
                                        ),
                                    });
                                    break;
                                case TimeSchedule.AFTER:
                                    setPriTime({
                                        ...defaultStartTime,
                                        default: moment(
                                            ranges[0][0],
                                            LONG_TIME_24H
                                        ),
                                    });
                                    break;
                                case TimeSchedule.BEFORE_OR_AFTER:
                                    setPriTime({
                                        ...defaultStartTime,
                                        default: moment(
                                            ranges[0][1],
                                            LONG_TIME_24H
                                        ),
                                    });
                                    setSecTime({
                                        ...defaultStartTime,
                                        default: moment(
                                            ranges[1][0],
                                            LONG_TIME_24H
                                        ),
                                    });
                                    break;
                                case TimeSchedule.EVERY:
                                    setDuration({
                                        default: daily_time_schedule_interval,
                                    });

                                    break;
                                case TimeSchedule.AT:
                                    setTimeList({
                                        ...defaultTimeArray,
                                        default: points,
                                    });
                                    break;
                                case TimeSchedule.BETWEEN:
                                    setTimeRangeList({
                                        ...defaultTimeArray,
                                        default: ranges,
                                    });
                                    break;
                            }

                            const dailyEndDateEnabled =
                                "end" in response.data.resource.date2;
                            const dailyStartDate =
                                moment(
                                    response.data.resource.date2.start,
                                    RECURRENCE_DATE_TIME_FORMAT
                                ) || defaultRecurrenceStartTime;
                            const dailyEndDate = dailyEndDateEnabled
                                ? moment(
                                      response.data.resource.date2.end,
                                      RECURRENCE_DATE_TIME_FORMAT
                                  )
                                : getDefaultRecurrenceEndTime({
                                      startTime: dailyStartDate,
                                      amount: 1,
                                      unit: "months",
                                  });

                            setRecurrenceRange({
                                ...recurrenceRange,
                                daily: {
                                    ...recurrenceRange[DAILY],
                                    startDate: dailyStartDate,

                                    endDate: dailyEndDate,

                                    endDateEnabled: dailyEndDateEnabled,
                                },
                            });

                            break;
                        }

                        case WEEKLY: {
                            const newCheckboxObj: any = { ...checkboxState };
                            const newTimeOptionObj: any = {
                                ...selectedTimeOption,
                            };
                            const newPriTimeObj: any = { ...priTime };
                            const newSecTimeObj: any = { ...secTime };
                            const newTimeListObj: any = { ...timeList };
                            const newTimeRangeListObj: any = {
                                ...timeRangeList,
                            };
                            const newDurationObj: any = { ...duration };

                            let t: any;
                            for (t in weekdays) {
                                const { schedule, points, ranges, interval } =
                                    weekdays[t];

                                newCheckboxObj[DaysOfWeek[t - 1]] = true;
                                newTimeOptionObj[DaysOfWeek[t - 1]] = schedule;

                                switch (schedule) {
                                    case TimeSchedule.BEFORE:
                                        newPriTimeObj[DaysOfWeek[t - 1]] =
                                            moment(ranges[0][1], LONG_TIME_24H);
                                        break;
                                    case TimeSchedule.AFTER:
                                        newPriTimeObj[DaysOfWeek[t - 1]] =
                                            moment(ranges[0][0], LONG_TIME_24H);
                                        break;
                                    case TimeSchedule.BEFORE_OR_AFTER:
                                        newPriTimeObj[DaysOfWeek[t - 1]] =
                                            moment(ranges[0][1], LONG_TIME_24H);
                                        newSecTimeObj[DaysOfWeek[t - 1]] =
                                            moment(ranges[1][0], LONG_TIME_24H);
                                        break;
                                    case TimeSchedule.AT:
                                        newTimeListObj[DaysOfWeek[t - 1]] =
                                            points;

                                        break;
                                    case TimeSchedule.BETWEEN:
                                        newTimeRangeListObj[DaysOfWeek[t - 1]] =
                                            ranges;
                                        break;
                                    case TimeSchedule.EVERY:
                                        newDurationObj[DaysOfWeek[t - 1]] =
                                            interval;
                                        break;
                                }
                            }

                            setCheckboxState(newCheckboxObj);
                            setSelectedTimeOption(newTimeOptionObj);
                            setPriTime(newPriTimeObj);
                            setSecTime(newSecTimeObj);
                            setTimeList(newTimeListObj);
                            setTimeRangeList(newTimeRangeListObj);
                            setDuration(newDurationObj);

                            const weeklyEndDateEnabled =
                                "end" in response.data.resource.date2;
                            const weeklyStartDate =
                                moment(
                                    response.data.resource.date2.start,
                                    RECURRENCE_DATE_TIME_FORMAT
                                ) || defaultRecurrenceStartTime;
                            const weeklyEndDate = weeklyEndDateEnabled
                                ? moment(
                                      response.data.resource.date2.end,
                                      RECURRENCE_DATE_TIME_FORMAT
                                  )
                                : getDefaultRecurrenceEndTime({
                                      startTime: weeklyStartDate,
                                      amount: 3,
                                      unit: "months",
                                  });

                            setRecurrenceRange({
                                ...recurrenceRange,
                                weekly: {
                                    ...recurrenceRange[WEEKLY],
                                    startDate: weeklyStartDate,

                                    endDate: weeklyEndDate,

                                    endDateEnabled: weeklyEndDateEnabled,
                                },
                            });

                            break;
                        }

                        case MONTHLY: {
                            const allExistingDates: any = [];
                            let priTimeMonthly: any = moment().startOf("day");
                            let secTimeMonthly: any = moment().startOf("day");
                            let timeListMonthly: any = [];
                            let timeRangeListMonthly: any = [];
                            let durationMonthly;

                            for (const d in monthly.days) {
                                const { ranges, points, schedule, interval } =
                                    monthly.days[d];

                                switch (schedule) {
                                    case TimeSchedule.BEFORE:
                                        priTimeMonthly = moment(
                                            ranges[0][1],
                                            LONG_TIME_24H
                                        );

                                        break;
                                    case TimeSchedule.AFTER:
                                        priTimeMonthly = moment(
                                            ranges[0][0],
                                            LONG_TIME_24H
                                        );

                                        break;

                                    case TimeSchedule.BEFORE_OR_AFTER:
                                        priTimeMonthly = moment(
                                            ranges[0][1],
                                            LONG_TIME_24H
                                        );
                                        secTimeMonthly = moment(
                                            ranges[1][0],
                                            LONG_TIME_24H
                                        );

                                        break;
                                    case TimeSchedule.BETWEEN:
                                        timeRangeListMonthly = ranges;
                                        break;
                                    case TimeSchedule.AT:
                                        timeListMonthly = points;
                                        break;
                                    case TimeSchedule.EVERY:
                                        durationMonthly = interval;
                                        break;
                                }

                                const dateObj = {
                                    type: "monthly_recurrence:day",
                                    day: d,
                                    selectedTimeOption: schedule,
                                    priTime: priTimeMonthly,
                                    secTime: secTimeMonthly,
                                    timeList: timeListMonthly,
                                    timeRangeList: timeRangeListMonthly,
                                    duration: durationMonthly,
                                };
                                allExistingDates.push(dateObj);
                            }

                            for (const d in monthly.weekdays) {
                                const { ranges, points, schedule, interval } =
                                    monthly.weekdays[d];
                                switch (schedule) {
                                    case TimeSchedule.BEFORE:
                                        priTimeMonthly = moment(
                                            ranges[0][1],
                                            LONG_TIME_24H
                                        );

                                        break;
                                    case TimeSchedule.AFTER:
                                        priTimeMonthly = moment(
                                            ranges[0][0],
                                            LONG_TIME_24H
                                        );

                                        break;

                                    case TimeSchedule.BEFORE_OR_AFTER:
                                        priTimeMonthly = moment(
                                            ranges[0][1],
                                            LONG_TIME_24H
                                        );
                                        secTimeMonthly = moment(
                                            ranges[1][0],
                                            LONG_TIME_24H
                                        );

                                        break;
                                    case TimeSchedule.BETWEEN:
                                        timeRangeListMonthly = ranges;
                                        break;
                                    case TimeSchedule.AT:
                                        timeListMonthly = points;
                                        break;
                                    case TimeSchedule.EVERY:
                                        durationMonthly = interval;
                                        break;
                                }

                                const dateObj = {
                                    type: "monthly_recurrence:firstLast",
                                    day: d,
                                    selectedTimeOption: schedule,
                                    priTime: priTimeMonthly,
                                    secTime: secTimeMonthly,
                                    timeList: timeListMonthly,
                                    timeRangeList: timeRangeListMonthly,
                                    duration: durationMonthly,
                                };
                                allExistingDates.push(dateObj);
                            }
                            setAllDates(allExistingDates);

                            const monthlyEndDateEnabled =
                                "end" in response.data.resource.date2;
                            const monthlyStartDate =
                                moment(
                                    response.data.resource.date2.start,
                                    RECURRENCE_DATE_TIME_FORMAT
                                ) || defaultRecurrenceStartTime;
                            const monthlyEndDate = monthlyEndDateEnabled
                                ? moment(
                                      response.data.resource.date2.end,
                                      RECURRENCE_DATE_TIME_FORMAT
                                  )
                                : getDefaultRecurrenceEndTime({
                                      startTime: monthlyStartDate,
                                      amount: 1,
                                      unit: "years",
                                  });
                            setRecurrenceRange({
                                ...recurrenceRange,
                                monthly: {
                                    ...recurrenceRange[MONTHLY],
                                    startDate: monthlyStartDate,

                                    endDate: monthlyEndDate,

                                    endDateEnabled: monthlyEndDateEnabled,
                                },
                            });

                            break;
                        }
                        case YEARLY: {
                            const allExistingYearlyDates: any = [];
                            let priTimeYearly: any = moment().startOf("day");
                            let secTimeYearly: any = moment().startOf("day");
                            let timeListYearly: any = [];
                            let timeRangeListYearly: any = [];
                            let durationYearly;

                            for (const m in yearly.months) {
                                for (const d in yearly.months[m].days) {
                                    const {
                                        months: {
                                            [m]: {
                                                days: {
                                                    [d]: {
                                                        points = null,
                                                        ranges = null,
                                                        schedule = "",
                                                        interval = null,
                                                    } = {},
                                                } = {},
                                            } = {},
                                        },
                                    } = yearly;
                                    switch (schedule) {
                                        case TimeSchedule.BEFORE:
                                            priTimeYearly = moment(
                                                ranges[0][1],
                                                LONG_TIME_24H
                                            );

                                            break;
                                        case TimeSchedule.AFTER:
                                            priTimeYearly = moment(
                                                ranges[0][0],
                                                LONG_TIME_24H
                                            );

                                            break;

                                        case TimeSchedule.BEFORE_OR_AFTER:
                                            priTimeYearly = moment(
                                                ranges[0][1],
                                                LONG_TIME_24H
                                            );
                                            secTimeYearly = moment(
                                                ranges[1][0],
                                                LONG_TIME_24H
                                            );

                                            break;
                                        case TimeSchedule.BETWEEN:
                                            timeRangeListYearly = ranges;
                                            break;
                                        case TimeSchedule.AT:
                                            timeListYearly = points;
                                            break;
                                        case TimeSchedule.EVERY:
                                            durationYearly = interval;
                                            break;
                                    }

                                    const dateObj = {
                                        type: "yearly_recurrence:day",
                                        day: d,
                                        month: MonthsMap[m].toLowerCase(),
                                        selectedTimeOption: schedule,
                                        priTime: priTimeYearly,
                                        secTime: secTimeYearly,
                                        timeList: timeListYearly,
                                        timeRangeList: timeRangeListYearly,
                                        duration: durationYearly,
                                    };

                                    allExistingYearlyDates.push(dateObj);
                                }

                                for (const d in yearly.months[m].weekdays) {
                                    const {
                                        months: {
                                            [m]: {
                                                weekdays: {
                                                    [d]: {
                                                        points = null,
                                                        ranges = null,
                                                        schedule = "",
                                                        interval = null,
                                                    } = {},
                                                } = {},
                                            } = {},
                                        },
                                    } = yearly;

                                    switch (schedule) {
                                        case TimeSchedule.BEFORE:
                                            priTimeYearly = moment(
                                                ranges[0][1],
                                                LONG_TIME_24H
                                            );

                                            break;
                                        case TimeSchedule.AFTER:
                                            priTimeYearly = moment(
                                                ranges[0][0],
                                                LONG_TIME_24H
                                            );

                                            break;

                                        case TimeSchedule.BEFORE_OR_AFTER:
                                            priTimeYearly = moment(
                                                ranges[0][1],
                                                LONG_TIME_24H
                                            );
                                            secTimeYearly = moment(
                                                ranges[1][0],
                                                LONG_TIME_24H
                                            );

                                            break;
                                        case TimeSchedule.BETWEEN:
                                            timeRangeListYearly = ranges;
                                            break;
                                        case TimeSchedule.AT:
                                            timeListYearly = points;
                                            break;
                                        case TimeSchedule.EVERY:
                                            durationYearly = interval;
                                            break;
                                    }

                                    const dateObj = {
                                        type: "yearly_recurrence:firstLast",
                                        day: d,
                                        month: MonthsMap[m].toLowerCase(),
                                        selectedTimeOption: schedule,
                                        priTime: priTimeYearly,
                                        secTime: secTimeYearly,
                                        timeList: timeListYearly,
                                        timeRangeList: timeRangeListYearly,
                                        duration: durationYearly,
                                    };

                                    allExistingYearlyDates.push(dateObj);
                                }
                            }
                            setAllDates(allExistingYearlyDates);

                            const yearlyEndDateEnabled =
                                "end" in response.data.resource.date2;
                            const yearlyStartDate =
                                moment(
                                    response.data.resource.date2.start,
                                    RECURRENCE_DATE_TIME_FORMAT
                                ) || defaultRecurrenceStartTime;
                            const yearlyEndDate = yearlyEndDateEnabled
                                ? moment(
                                      response.data.resource.date2.end,
                                      RECURRENCE_DATE_TIME_FORMAT
                                  )
                                : getDefaultRecurrenceEndTime({
                                      startTime: yearlyStartDate,
                                      amount: 5,
                                      unit: "years",
                                  });

                            setRecurrenceRange({
                                ...recurrenceRange,
                                yearly: {
                                    ...recurrenceRange[YEARLY],
                                    startDate: yearlyStartDate,

                                    endDate: yearlyEndDate,

                                    endDateEnabled: yearlyEndDateEnabled,
                                },
                            });

                            break;
                        }
                    }
                    setIsPageLoading(false);
                } else {
                    setIsPageLoading(false);
                    openModal({
                        key: "condition_recurrence_error",
                        modalType: "err",
                        modalContent: response.data.description,
                        okAction: () => {
                            backToEventPage();
                        },
                    });
                }
            };
            fetchCondition();
        } else {
            setIsPageLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal, backToEventPage]);

    const renderErrorMsg = (
        component: any,
        field: any,
        day?: any,
        month?: any
    ) => {
        if (component === error.component) {
            switch (field) {
                case "repeat":
                    switch (error.errorType) {
                        case ERROR_NO_INTERVAL:
                            return (
                                <Col sm="12" className="mt-2">
                                    <p className="text-danger">
                                        Please enter an interval.
                                    </p>
                                </Col>
                            );
                        case ERROR_NOT_POSITIVE_INTEGER:
                            return (
                                <Col sm="12" className="mt-2">
                                    <p className="text-danger">
                                        Please enter a whole number that is
                                        greater than 0.
                                    </p>
                                </Col>
                            );
                    }
                    break;
                case "range":
                    if (error.errorType === ERROR_INVALID_DATE) {
                        return (
                            <Col sm="12" className="mt-2">
                                <p className="text-danger">
                                    Invalid date format.
                                </p>
                            </Col>
                        );
                    }
                    break;

                case "timeSchedule":
                    if (month) {
                        if (error.month === month && error.day === day) {
                            switch (error.errorType) {
                                case ERROR_NO_DURATION:
                                    return (
                                        <Col sm="12" className="mt-2">
                                            <p className="text-danger">
                                                {ERROR_NO_DURATION}
                                            </p>
                                        </Col>
                                    );

                                case ERROR_INVALID:
                                    return (
                                        <Col sm="12" className="mt-2">
                                            <p className="text-danger">
                                                Invalid time format.
                                            </p>
                                        </Col>
                                    );
                                case ERROR_EMPTY:
                                    return (
                                        <Col sm="12" className="mt-2">
                                            <p className="text-danger">
                                                Please set a time schedule.
                                            </p>
                                        </Col>
                                    );
                                case ERROR_INCORRECT_VALUE:
                                    return (
                                        <Col sm="12" className="mt-2">
                                            <p className="text-danger">
                                                The value needs to be at least 5
                                                seconds.
                                            </p>
                                        </Col>
                                    );
                                case ERROR_INVALID_BEFORE_AFTER_DATE:
                                    return (
                                        <Col sm="12" className="mt-2">
                                            <p className="text-danger">
                                                {invalidBeforeAfterDateMsg}
                                            </p>
                                        </Col>
                                    );
                                case ERROR_BEFORE_OR_AFTER:
                                    return (
                                        <Col sm="12" className="mt-2">
                                            <p className="text-danger">
                                                {ERROR_BEFORE_OR_AFTER}
                                            </p>
                                        </Col>
                                    );
                            }
                            break;
                        }
                    } else if (error.day === day) {
                        switch (error.errorType) {
                            case ERROR_NO_DURATION:
                                return (
                                    <Col sm="12" className="mt-2">
                                        <p className="text-danger">
                                            {ERROR_NO_DURATION}
                                        </p>
                                    </Col>
                                );

                            case ERROR_INVALID:
                                return (
                                    <Col sm="12" className="mt-2">
                                        <p className="text-danger">
                                            Invalid time format.
                                        </p>
                                    </Col>
                                );
                            case ERROR_EMPTY:
                                return (
                                    <Col sm="12" className="mt-2">
                                        <p className="text-danger">
                                            Please set a time schedule.
                                        </p>
                                    </Col>
                                );
                            case ERROR_INCORRECT_VALUE:
                                return (
                                    <Col sm="12" className="mt-2">
                                        <p className="text-danger">
                                            The value needs to be at least 5
                                            seconds.
                                        </p>
                                    </Col>
                                );
                            case ERROR_INVALID_BEFORE_AFTER_DATE:
                                return (
                                    <Col sm="12" className="mt-2">
                                        <p className="text-danger">
                                            {invalidBeforeAfterDateMsg}
                                        </p>
                                    </Col>
                                );
                            case ERROR_BEFORE_OR_AFTER:
                                return (
                                    <Col sm="12" className="mt-2">
                                        <p className="text-danger">
                                            {ERROR_BEFORE_OR_AFTER}
                                        </p>
                                    </Col>
                                );
                        }
                        break;
                    }
            }
        }
    };

    const handleAddUpdateCondition = async () => {
        let response: any;
        setInvalidBeforeAfterDateMsg("");

        let slot = 0;
        if (selectedOperator === "AND") {
            slot = selectedSlotIndex;
        } else if (selectedOperator === "OR") {
            slot = slotCount;
        }

        switch (selectedRepeatOption) {
            case DAILY:
                switch (selectedTimeOption.default) {
                    case TimeSchedule.EVERY:
                        if (!duration.default) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_NO_DURATION,
                                day: "default",
                            });
                            return;
                        }

                        if (
                            selectedInterval.default === "seconds" &&
                            Number(duration.default) < 5
                        ) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INCORRECT_VALUE,
                                day: "default",
                            });
                            return;
                        }
                        break;
                    case TimeSchedule.BEFORE:
                    case TimeSchedule.AFTER:
                    case TimeSchedule.BEFORE_OR_AFTER:
                        setInvalidBeforeAfterDateMsg("");
                        if (
                            !moment(
                                priTime.default.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day")) ||
                            !moment(
                                secTime.default.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day"))
                        ) {
                            if (
                                selectedTimeOption.default ===
                                TimeSchedule.BEFORE
                            ) {
                                setInvalidBeforeAfterDateMsg(
                                    "The time entered for 'Before' must be later than 12:00 AM"
                                );
                            }

                            if (
                                selectedTimeOption.default ===
                                TimeSchedule.AFTER
                            ) {
                                setInvalidBeforeAfterDateMsg(
                                    "The time entered for 'After' must be later than 12:00 AM"
                                );
                            }

                            if (
                                selectedTimeOption.default ===
                                TimeSchedule.BEFORE_OR_AFTER
                            ) {
                                setInvalidBeforeAfterDateMsg(
                                    "The time entered for 'Before' and 'After' must be later than 12:00 AM"
                                );
                            }

                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID_BEFORE_AFTER_DATE,
                                day: "default",
                            });
                            return;
                        }

                        if (
                            selectedTimeOption.default ===
                                TimeSchedule.BEFORE_OR_AFTER &&
                            priTime.default.isSameOrAfter(secTime.default)
                        ) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_BEFORE_OR_AFTER,
                                day: "default",
                            });
                            return;
                        }

                        if (
                            !priTime.default._isValid ||
                            !secTime.default._isValid
                        ) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID,
                                day: "default",
                            });
                            return;
                        }
                        break;
                    case TimeSchedule.AT:
                        if (!timeList.default.length) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_EMPTY,
                                day: "default",
                            });
                            return;
                        }
                        break;
                    case TimeSchedule.BETWEEN:
                        if (!timeRangeList.default.length) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_EMPTY,
                                day: "default",
                            });
                            return;
                        }
                        break;
                }
                break;
            case WEEKLY: {
                const checked = [];

                const list = [
                    "sunday",
                    "monday",
                    "tuesday",
                    "wednesday",
                    "thursday",
                    "friday",
                    "saturday",
                ];
                for (let day of list) {
                    if (checkboxState[day]) {
                        checked.push(day);
                    }
                    switch (selectedTimeOption[day]) {
                        case TimeSchedule.EVERY:
                            if (checkboxState[day]) {
                                if (!duration[day]) {
                                    setError({
                                        component: selectedRepeatOption,
                                        errorType: ERROR_NO_DURATION,
                                        day: day,
                                    });
                                    return;
                                }
                                if (
                                    selectedInterval[day] === "seconds" &&
                                    Number(duration[day]) < 5
                                ) {
                                    setError({
                                        component: selectedRepeatOption,
                                        errorType: ERROR_INCORRECT_VALUE,
                                        day: day,
                                    });
                                    return;
                                }
                            }
                            break;
                        case TimeSchedule.BEFORE:
                        case TimeSchedule.AFTER:
                        case TimeSchedule.BEFORE_OR_AFTER:
                            setInvalidBeforeAfterDateMsg("");
                            if (checkboxState[day]) {
                                if (
                                    !moment(
                                        priTime[day].format(LONG_TIME_24H),
                                        LONG_TIME_24H
                                    ).isAfter(moment().startOf("day")) &&
                                    selectedTimeOption[day] ===
                                        TimeSchedule.BEFORE
                                ) {
                                    setInvalidBeforeAfterDateMsg(
                                        "The time entered for 'Before' must be later than 12:00 AM"
                                    );

                                    setError({
                                        component: selectedRepeatOption,
                                        errorType:
                                            ERROR_INVALID_BEFORE_AFTER_DATE,
                                        day: day,
                                    });
                                    return;
                                }

                                if (
                                    !moment(
                                        priTime[day].format(LONG_TIME_24H),
                                        LONG_TIME_24H
                                    ).isAfter(moment().startOf("day")) &&
                                    selectedTimeOption[day] ===
                                        TimeSchedule.AFTER
                                ) {
                                    setInvalidBeforeAfterDateMsg(
                                        "The time entered for 'After' must be later than 12:00 AM"
                                    );

                                    setError({
                                        component: selectedRepeatOption,
                                        errorType:
                                            ERROR_INVALID_BEFORE_AFTER_DATE,
                                        day: day,
                                    });
                                    return;
                                }

                                if (
                                    (!moment(
                                        priTime[day].format(LONG_TIME_24H),
                                        LONG_TIME_24H
                                    ).isAfter(moment().startOf("day")) ||
                                        !moment(
                                            secTime[day].format(LONG_TIME_24H),
                                            LONG_TIME_24H
                                        ).isAfter(moment().startOf("day"))) &&
                                    selectedTimeOption[day] ===
                                        TimeSchedule.BEFORE_OR_AFTER
                                ) {
                                    setInvalidBeforeAfterDateMsg(
                                        "The time entered for 'Before' and 'After' must be later than 12:00 AM"
                                    );

                                    setError({
                                        component: selectedRepeatOption,
                                        errorType:
                                            ERROR_INVALID_BEFORE_AFTER_DATE,
                                        day: day,
                                    });
                                    return;
                                }

                                if (
                                    selectedTimeOption[day] ===
                                        TimeSchedule.BEFORE_OR_AFTER &&
                                    priTime[day].isSameOrAfter(secTime[day])
                                ) {
                                    setError({
                                        component: selectedRepeatOption,
                                        errorType: ERROR_BEFORE_OR_AFTER,
                                        day: day,
                                    });
                                    return;
                                }

                                if (
                                    !priTime[day]._isValid ||
                                    !secTime[day]._isValid
                                ) {
                                    setError({
                                        component: selectedRepeatOption,
                                        errorType: ERROR_INVALID,
                                        day: day,
                                    });
                                    return;
                                }
                            }
                            break;
                        case TimeSchedule.AT:
                            if (checkboxState[day]) {
                                if (!timeList[day].length) {
                                    setError({
                                        component: selectedRepeatOption,
                                        errorType: ERROR_EMPTY,
                                        day: day,
                                    });
                                    return;
                                }
                            }
                            break;
                        case TimeSchedule.BETWEEN:
                            if (checkboxState[day]) {
                                if (!timeRangeList[day].length) {
                                    setError({
                                        component: selectedRepeatOption,
                                        errorType: ERROR_EMPTY,
                                        day: day,
                                    });
                                    return;
                                }
                            }
                            break;
                    }
                }
                if (checked.length === 0) {
                    setModalShow(true);
                    setModalType("err");
                    setModalContent(ERROR_RECURRENCE_WEEKLY_DAY);
                    return;
                }
                break;
            }
            case MONTHLY: {
                const monthlyDates = allDates.filter((m: any) => {
                    return m.type.includes("monthly");
                });

                for (let date of monthlyDates) {
                    if (date.selectedTimeOption === TimeSchedule.EVERY) {
                        if (!date.duration) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_NO_DURATION,
                                day: date.day,
                            });
                            return;
                        }

                        if (
                            date.selectedInterval === "seconds" &&
                            Number(date.duration) < 5
                        ) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INCORRECT_VALUE,
                                day: date.day,
                            });
                            return;
                        }
                    } else if (
                        [
                            TimeSchedule.BEFORE,
                            TimeSchedule.AFTER,
                            TimeSchedule.BEFORE_OR_AFTER,
                        ].includes(date.selectedTimeOption)
                    ) {
                        if (
                            date.selectedTimeOption === TimeSchedule.BEFORE &&
                            !moment(
                                date.priTime.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day"))
                        ) {
                            setInvalidBeforeAfterDateMsg(
                                "The time entered for 'Before' must be later than 12:00 AM"
                            );

                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID_BEFORE_AFTER_DATE,
                                day: date.day,
                            });
                            return;
                        }

                        if (
                            date.selectedTimeOption === TimeSchedule.AFTER &&
                            !moment(
                                date.priTime.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day"))
                        ) {
                            setInvalidBeforeAfterDateMsg(
                                "The time entered for 'After' must be later than 12:00 AM"
                            );

                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID_BEFORE_AFTER_DATE,
                                day: date.day,
                            });
                            return;
                        }

                        if (
                            (!moment(
                                date.priTime.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day")) ||
                                !moment(
                                    date.secTime.format(LONG_TIME_24H),
                                    LONG_TIME_24H
                                ).isAfter(moment().startOf("day"))) &&
                            date.selectedTimeOption ===
                                TimeSchedule.BEFORE_OR_AFTER
                        ) {
                            setInvalidBeforeAfterDateMsg(
                                "The time entered for 'Before' and 'After' must be later than 12:00 AM"
                            );

                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID_BEFORE_AFTER_DATE,
                                day: date.day,
                            });
                            return;
                        }

                        if (
                            date.selectedTimeOption ===
                                TimeSchedule.BEFORE_OR_AFTER &&
                            date.priTime.isSameOrAfter(date.secTime)
                        ) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_BEFORE_OR_AFTER,
                                day: date.day,
                            });
                            return;
                        }

                        if (!date.priTime._isValid || !date.secTime._isValid) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID,
                                day: date.day,
                            });
                            return;
                        }
                    } else if (date.selectedTimeOption === TimeSchedule.AT) {
                        if (!date.timeList.length) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_EMPTY,
                                day: date.day,
                            });
                            return;
                        }
                    } else if (
                        date.selectedTimeOption === TimeSchedule.BETWEEN
                    ) {
                        if (!date.timeRangeList.length) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_EMPTY,
                                day: date.day,
                            });
                            return;
                        }
                    }
                }

                break;
            }
            case YEARLY: {
                const yearlyDates = allDates.filter((y: any) => {
                    return y.type.includes("yearly");
                });

                for (let date of yearlyDates) {
                    if (date.selectedTimeOption === TimeSchedule.EVERY) {
                        if (!date.duration) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_NO_DURATION,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }

                        if (
                            date.selectedInterval === "seconds" &&
                            Number(date.duration) < 5
                        ) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INCORRECT_VALUE,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }
                    } else if (
                        [
                            TimeSchedule.BEFORE,
                            TimeSchedule.AFTER,
                            TimeSchedule.BEFORE_OR_AFTER,
                        ].includes(date.selectedTimeOption)
                    ) {
                        if (
                            date.selectedTimeOption === TimeSchedule.BEFORE &&
                            !moment(
                                date.priTime.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day"))
                        ) {
                            setInvalidBeforeAfterDateMsg(
                                "The time entered for 'Before' must be later than 12:00 AM"
                            );

                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID_BEFORE_AFTER_DATE,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }

                        if (
                            date.selectedTimeOption === TimeSchedule.AFTER &&
                            !moment(
                                date.priTime.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day"))
                        ) {
                            setInvalidBeforeAfterDateMsg(
                                "The time entered for 'After' must be later than 12:00 AM"
                            );

                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID_BEFORE_AFTER_DATE,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }

                        if (
                            (!moment(
                                date.priTime.format(LONG_TIME_24H),
                                LONG_TIME_24H
                            ).isAfter(moment().startOf("day")) ||
                                !moment(
                                    date.secTime.format(LONG_TIME_24H),
                                    LONG_TIME_24H
                                ).isAfter(moment().startOf("day"))) &&
                            date.selectedTimeOption ===
                                TimeSchedule.BEFORE_OR_AFTER
                        ) {
                            setInvalidBeforeAfterDateMsg(
                                "The time entered for 'Before' and 'After' must be later than 12:00 AM"
                            );

                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID_BEFORE_AFTER_DATE,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }

                        if (
                            date.selectedTimeOption ===
                                TimeSchedule.BEFORE_OR_AFTER &&
                            date.priTime.isSameOrAfter(date.secTime)
                        ) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_BEFORE_OR_AFTER,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }

                        if (!date.priTime._isValid || !date.secTime._isValid) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_INVALID,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }
                    } else if (date.selectedTimeOption === TimeSchedule.AT) {
                        if (!date.timeList.length) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_EMPTY,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }
                    } else if (
                        date.selectedTimeOption === TimeSchedule.BETWEEN
                    ) {
                        if (!date.timeRangeList.length) {
                            setError({
                                component: selectedRepeatOption,
                                errorType: ERROR_EMPTY,
                                day: date.day,
                                month: date.month,
                            });
                            return;
                        }
                    }
                }
                break;
            }
        }

        const validateRecurrenceDate = ({ start, end }: any) => {
            if (recurrenceErrorMsg) {
                return recurrenceErrorMsg;
            }
            const startYear = moment(start).year();
            const MINIMUM_RECURRENCE_YEAR = 1900;
            const MAXIMUM_RECURRENCE_YEAR = 2099;
            if (end) {
                const endYear = moment(end).year();
                if (moment(end).isSameOrBefore(moment(), "minute")) {
                    return "The end date and time cannot be in the past. Please select a future date and time.";
                } else if (
                    moment(end).isSameOrBefore(moment(start), "minute")
                ) {
                    return "The end date and time cannot be earlier than the start date and time. Please choose a valid date and time range.";
                } else if (
                    (startYear < MINIMUM_RECURRENCE_YEAR ||
                        startYear > MAXIMUM_RECURRENCE_YEAR) &&
                    (endYear < moment().year() ||
                        endYear > MAXIMUM_RECURRENCE_YEAR)
                ) {
                    return `The start year should be between ${MINIMUM_RECURRENCE_YEAR} and ${MAXIMUM_RECURRENCE_YEAR} and the end year should be between ${moment().year()} and ${MAXIMUM_RECURRENCE_YEAR}.`;
                } else if (
                    endYear < moment().year() ||
                    endYear > MAXIMUM_RECURRENCE_YEAR
                ) {
                    return `The end year should be between ${moment().year()} and ${MAXIMUM_RECURRENCE_YEAR}.`;
                }
            }

            if (
                startYear < MINIMUM_RECURRENCE_YEAR ||
                startYear > MAXIMUM_RECURRENCE_YEAR
            ) {
                return `The start year should be between ${MINIMUM_RECURRENCE_YEAR} and ${MAXIMUM_RECURRENCE_YEAR}.`;
            }
            return "";
        };

        if (!params.conditionId) {
            let body: any;

            switch (selectedRepeatOption) {
                case DAILY: {
                    const dailyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    body = {
                        slot: slot,
                        type_: `DATETIME`,
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(dailyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: DAILY,
                                interval: Number(
                                    repeatIntervalVal[DAILY].value
                                ),
                                [DAILY]: EventService.getEventTimeRange(
                                    selectedTimeOption.default,
                                    priTime.default,
                                    secTime.default,
                                    timeList.default,
                                    timeRangeList.default,
                                    duration.default
                                ),
                            },
                        },
                    };

                    break;
                }
                case WEEKLY: {
                    const weeklyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    let d: any;
                    const weekdayObj: any = {};

                    for (d of DaysOfWeek) {
                        if (checkboxState[d]) {
                            weekdayObj[DaysOfWeek.indexOf(d) + 1] =
                                EventService.getEventTimeRange(
                                    selectedTimeOption[d],
                                    priTime[d],
                                    secTime[d],
                                    timeList[d],
                                    timeRangeList[d],
                                    duration[d]
                                );
                        }
                    }

                    body = {
                        slot: slot,
                        type_: `DATETIME`,
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(weeklyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: WEEKLY,
                                interval: Number(
                                    repeatIntervalVal[WEEKLY].value
                                ),
                                [WEEKLY]: {
                                    weekdays: weekdayObj,
                                },
                            },
                        },
                    };

                    break;
                }
                case MONTHLY: {
                    const monthlyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    const monthlyWeekdayObj: any = {};
                    const monthlyDayObj: any = {};
                    // filter out monthly dates using filter function
                    const monthlyDates = allDates.filter((m: any) => {
                        return m.type.includes("monthly");
                    });

                    for (const d of monthlyDates) {
                        if (d.type === "monthly_recurrence:day") {
                            // monthly_recurrence:day
                            monthlyDayObj[d.day] =
                                EventService.getEventTimeRange(
                                    d.selectedTimeOption,
                                    d.priTime,
                                    d.secTime,
                                    d.timeList,
                                    d.timeRangeList,
                                    d.duration
                                );
                        } else {
                            // monthly_recurrence:firstLast

                            monthlyWeekdayObj[d.day] =
                                EventService.getEventTimeRange(
                                    d.selectedTimeOption,
                                    d.priTime,
                                    d.secTime,
                                    d.timeList,
                                    d.timeRangeList,
                                    d.duration
                                );
                        }
                    }

                    if (!monthlyDates.length) {
                        setModalShow(true);
                        setModalType("err");
                        setModalContent("Please select a recurring day.");
                        return;
                    }

                    body = {
                        slot: slot,
                        type_: `DATETIME`,
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(monthlyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: MONTHLY,
                                interval: Number(
                                    repeatIntervalVal[MONTHLY].value
                                ),
                                [MONTHLY]: {
                                    weekdays: monthlyWeekdayObj,
                                    days: monthlyDayObj,
                                },
                            },
                        },
                    };

                    // remove either weekdays or days if empty {}
                    if (isEmpty(body.resource.date2[MONTHLY].weekdays))
                        delete body.resource.date2[MONTHLY].weekdays;
                    if (isEmpty(body.resource.date2[MONTHLY].days))
                        delete body.resource.date2[MONTHLY].days;

                    break;
                }
                case YEARLY: {
                    const yearlyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    const yearlyMonthObj: any = {};
                    // filter out yearly dates using filter function
                    const yearlyDates = allDates.filter((m: any) => {
                        return m.type.includes("yearly");
                    });

                    for (const d of yearlyDates) {
                        const monthlyVal: any = Object.keys(MonthsMap).find(
                            (key: any) =>
                                MonthsMap[key].toLowerCase() === d.month
                        );

                        // yearly_recurrence:day
                        if (d.type === "yearly_recurrence:day") {
                            yearlyMonthObj[monthlyVal] = {
                                // ... yearlyMonthObj,
                                // eslint-disable-next-line no-useless-computed-key
                                ["days"]: {
                                    ...yearlyMonthObj[monthlyVal]?.["days"],
                                    [d.day]: EventService.getEventTimeRange(
                                        d.selectedTimeOption,
                                        d.priTime,
                                        d.secTime,
                                        d.timeList,
                                        d.timeRangeList,
                                        d.duration
                                    ),
                                },
                            };
                        } else {
                            // yearly_recurrence:firstLast

                            yearlyMonthObj[monthlyVal] = {
                                // ... yearlyMonthObj,
                                // eslint-disable-next-line no-useless-computed-key
                                ["weekdays"]: {
                                    ...yearlyMonthObj[monthlyVal]?.["weekdays"],
                                    [d.day]: EventService.getEventTimeRange(
                                        d.selectedTimeOption,
                                        d.priTime,
                                        d.secTime,
                                        d.timeList,
                                        d.timeRangeList,
                                        d.duration
                                    ),
                                },
                            };
                        }
                    }

                    if (!yearlyDates.length) {
                        setModalShow(true);
                        setModalType("err");
                        setModalContent("Please select a recurring day.");
                        return;
                    }

                    body = {
                        slot: slot,
                        type_: `DATETIME`,
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(yearlyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: YEARLY,
                                interval: Number(
                                    repeatIntervalVal[YEARLY].value
                                ),
                                [YEARLY]: {
                                    months: yearlyMonthObj,
                                },
                            },
                        },
                    };

                    break;
                }
            }

            const recurrenceError = validateRecurrenceDate(body.resource.date2);
            if (recurrenceError) {
                setRecurrenceErrorMsg(recurrenceError);
                return;
            }

            response = await EventService.createCondition(params.eventId, body);
        } else {
            let body: any;

            switch (selectedRepeatOption) {
                case DAILY: {
                    const dailyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    body = {
                        slot: currentRecurrenceDetail.slot,
                        type_: "DATETIME",
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(dailyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: DAILY,
                                interval: Number(
                                    repeatIntervalVal[DAILY].value
                                ),
                                [DAILY]: EventService.getEventTimeRange(
                                    selectedTimeOption.default,
                                    priTime.default,
                                    secTime.default,
                                    timeList.default,
                                    timeRangeList.default,
                                    duration.default
                                ),
                            },
                        },
                    };

                    break;
                }
                case WEEKLY: {
                    const weeklyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    let d: any;
                    const weekdayObj: any = {};

                    for (d of DaysOfWeek) {
                        if (checkboxState[d]) {
                            weekdayObj[DaysOfWeek.indexOf(d) + 1] =
                                EventService.getEventTimeRange(
                                    selectedTimeOption[d],
                                    priTime[d],
                                    secTime[d],
                                    timeList[d],
                                    timeRangeList[d],
                                    duration[d]
                                );
                        }
                    }

                    body = {
                        slot: currentRecurrenceDetail.slot,
                        type_: `DATETIME`,
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(weeklyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: WEEKLY,
                                interval: Number(
                                    repeatIntervalVal[WEEKLY].value
                                ),
                                [WEEKLY]: {
                                    weekdays: weekdayObj,
                                },
                            },
                        },
                    };

                    break;
                }
                case MONTHLY: {
                    const monthlyWeekdayObj: any = {};
                    const monthlyDayObj: any = {};
                    // filter out monthly dates using filter function
                    const monthlyDates = allDates.filter((m: any) => {
                        return m.type.includes("monthly");
                    });

                    for (const d of monthlyDates) {
                        if (d.type === "monthly_recurrence:day") {
                            // monthly_recurrence:day
                            monthlyDayObj[d.day] =
                                EventService.getEventTimeRange(
                                    d.selectedTimeOption,
                                    d.priTime,
                                    d.secTime,
                                    d.timeList,
                                    d.timeRangeList,
                                    d.duration
                                );
                        } else {
                            // monthly_recurrence:firstLast
                            monthlyWeekdayObj[d.day] =
                                EventService.getEventTimeRange(
                                    d.selectedTimeOption,
                                    d.priTime,
                                    d.secTime,
                                    d.timeList,
                                    d.timeRangeList,
                                    d.duration
                                );
                        }
                    }

                    if (!monthlyDates.length) {
                        setModalShow(true);
                        setModalType("err");
                        setModalContent("Please select a recurring day.");
                        return;
                    }
                    const monthlyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    body = {
                        slot: currentRecurrenceDetail.slot,
                        type_: `DATETIME`,
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(monthlyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: MONTHLY,
                                interval: Number(
                                    repeatIntervalVal[MONTHLY].value
                                ),
                                [MONTHLY]: {
                                    weekdays: monthlyWeekdayObj,
                                    days: monthlyDayObj,
                                },
                            },
                        },
                    };

                    // remove either weekdays or days if empty {}
                    if (isEmpty(body.resource.date2[MONTHLY].weekdays))
                        delete body.resource.date2[MONTHLY].weekdays;
                    if (isEmpty(body.resource.date2[MONTHLY].days))
                        delete body.resource.date2[MONTHLY].days;

                    break;
                }
                case YEARLY: {
                    const yearlyMonthObj: any = {};
                    // filter out yearly dates using filter function
                    const yearlyDates = allDates.filter((m: any) => {
                        return m.type.includes("yearly");
                    });

                    for (const d of yearlyDates) {
                        const monthlyVal: any = Object.keys(MonthsMap).find(
                            (key: any) =>
                                MonthsMap[key].toLowerCase() === d.month
                        );

                        // yearly_recurrence:day
                        if (d.type === "yearly_recurrence:day") {
                            yearlyMonthObj[monthlyVal] = {
                                // ... yearlyMonthObj,
                                // eslint-disable-next-line no-useless-computed-key
                                ["days"]: {
                                    ...yearlyMonthObj[monthlyVal]?.["days"],
                                    [d.day]: EventService.getEventTimeRange(
                                        d.selectedTimeOption,
                                        d.priTime,
                                        d.secTime,
                                        d.timeList,
                                        d.timeRangeList,
                                        d.duration
                                    ),
                                },
                            };
                        } else {
                            // yearly_recurrence:firstLast

                            yearlyMonthObj[monthlyVal] = {
                                // ... yearlyMonthObj,
                                // eslint-disable-next-line no-useless-computed-key
                                ["weekdays"]: {
                                    ...yearlyMonthObj[monthlyVal]?.["weekdays"],
                                    [d.day]: EventService.getEventTimeRange(
                                        d.selectedTimeOption,
                                        d.priTime,
                                        d.secTime,
                                        d.timeList,
                                        d.timeRangeList,
                                        d.duration
                                    ),
                                },
                            };
                        }
                    }

                    if (!yearlyDates.length) {
                        setModalShow(true);
                        setModalType("err");
                        setModalContent("Please select a recurring day.");
                        return;
                    }
                    const yearlyEndDateEnabled =
                        recurrenceRange[selectedRepeatOption].endDateEnabled;

                    body = {
                        slot: currentRecurrenceDetail.slot,
                        type_: `DATETIME`,
                        resource: {
                            date2: {
                                start: recurrenceRange[
                                    selectedRepeatOption
                                ].startDate.format(RECURRENCE_DATE_TIME_FORMAT),
                                ...(yearlyEndDateEnabled
                                    ? {
                                          end: recurrenceRange[
                                              selectedRepeatOption
                                          ].endDate.format(
                                              RECURRENCE_DATE_TIME_FORMAT
                                          ),
                                      }
                                    : {}),
                                repeat: YEARLY,
                                interval: Number(
                                    repeatIntervalVal[YEARLY].value
                                ),
                                [YEARLY]: {
                                    months: yearlyMonthObj,
                                },
                            },
                        },
                    };

                    break;
                }
            }

            const recurrenceError = validateRecurrenceDate(body.resource.date2);
            if (recurrenceError) {
                setRecurrenceErrorMsg(recurrenceError);
                return;
            }

            response = await EventService.updateCondition(
                params.eventId,
                params.conditionId,
                {
                    ...body,
                }
            );
        }
        if (isHttpSuccess(response.status)) {
            backToEventPage();
        } else if (response.data?.errors) {
            const errors: any = [];
            for (const err of response.data?.errors || []) {
                !errors.includes(...err.value) &&
                    errors.push(`Time Schedule: ${[...err.value]}`);
            }
            setModalShow(true);
            setModalType("err");
            setErrorArray(errors);
        } else {
            setSimpleModalData({
                resObj: response,
            } as SimpleModalDataType);
        }
    };

    const renderRepeatOption = () => {
        switch (selectedRepeatOption) {
            case DAILY:
                return (
                    <Daily
                        priTime={priTime}
                        setPriTime={updatePriTime}
                        secTime={secTime}
                        setSecTime={updateSecTime}
                        selectedTimeOption={selectedTimeOption}
                        setSelectedTimeOption={updateSelectedTimeOption}
                        selectedInterval={selectedInterval}
                        setSelectedInterval={updateSelectedInterval}
                        duration={duration}
                        setDuration={updateDuration}
                        timeList={timeList}
                        setTimeList={updateTimeList}
                        timeRangeList={timeRangeList}
                        setTimeRangeList={updateTimeRangeList}
                        errorType={errorType}
                        setErrorType={updateErrorType}
                        day={"default"}
                        setRecurrenceRange={updateRecurrenceRange}
                        recurrenceRange={recurrenceRange}
                        renderErrorMsg={renderErrorMsg}
                        recurrenceErrorMsg={recurrenceErrorMsg}
                        updateRecurrenceErrorMsg={updateRecurrenceErrorMsg}
                        clearParentError={clearParentError}
                    />
                );

            case WEEKLY:
                return (
                    <Weekly
                        priTime={priTime}
                        setPriTime={updatePriTime}
                        secTime={secTime}
                        setSecTime={updateSecTime}
                        selectedTimeOption={selectedTimeOption}
                        setSelectedTimeOption={updateSelectedTimeOption}
                        selectedInterval={selectedInterval}
                        setSelectedInterval={updateSelectedInterval}
                        duration={duration}
                        setDuration={updateDuration}
                        timeList={timeList}
                        setTimeList={updateTimeList}
                        timeRangeList={timeRangeList}
                        setTimeRangeList={updateTimeRangeList}
                        errorType={errorType}
                        setErrorType={updateErrorType}
                        checkboxState={checkboxState}
                        setCheckboxState={updateCheckboxState}
                        setRecurrenceRange={updateRecurrenceRange}
                        recurrenceRange={recurrenceRange}
                        renderErrorMsg={renderErrorMsg}
                        recurrenceErrorMsg={recurrenceErrorMsg}
                        updateRecurrenceErrorMsg={updateRecurrenceErrorMsg}
                        clearParentError={clearParentError}
                    />
                );
            case MONTHLY:
                return (
                    <Monthly
                        allDates={allDates}
                        setAllDates={updateAllDates}
                        setRecurrenceRange={updateRecurrenceRange}
                        recurrenceRange={recurrenceRange}
                        renderErrorMsg={renderErrorMsg}
                        onChangeTimeOption={(date: any) => {
                            setError({
                                component: selectedRepeatOption,
                                errorType: "",
                                day: date.day,
                            });
                        }}
                        recurrenceErrorMsg={recurrenceErrorMsg}
                        updateRecurrenceErrorMsg={updateRecurrenceErrorMsg}
                        clearParentError={clearParentError}
                    />
                );

            case YEARLY:
                return (
                    <Yearly
                        allDates={allDates}
                        setAllDates={updateAllDates}
                        setRecurrenceRange={updateRecurrenceRange}
                        recurrenceRange={recurrenceRange}
                        renderErrorMsg={renderErrorMsg}
                        onChangeTimeOption={(date: any) => {
                            setError({
                                component: selectedRepeatOption,
                                errorType: "",
                                day: date.day,
                                month: date.month,
                            });
                        }}
                        recurrenceErrorMsg={recurrenceErrorMsg}
                        updateRecurrenceErrorMsg={updateRecurrenceErrorMsg}
                        clearParentError={clearParentError}
                    />
                );
        }
    };

    return (
        <ContentWrapper
            isLoading={isPageLoading}
            simpleModalData={simpleModalData}
        >
            <Container>
                <Row>
                    <Col sm="12" className="event-detail-head">
                        <h5 className="page-title overflow-text">Recurrence</h5>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Breadcrumb className="w-100">
                            <Breadcrumb.Item>
                                <Link to="/events">Events</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link to={`/event-details/${params.eventId}`}>
                                    Event Details
                                </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Condition</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row className="action-detail-box">
                    <Col>
                        <RepeatOption
                            value={selectedRepeatOption}
                            onChange={(value: string) => {
                                setRecurrenceErrorMsg("");
                                setSelectedRepeatOption(value);
                            }}
                        ></RepeatOption>

                        <RepeatInterval
                            repeatIntervalValue={
                                repeatIntervalVal[selectedRepeatOption]
                            }
                            onChange={(value: RepeatIntervalValue) => {
                                setRepeatIntervalVal({
                                    ...repeatIntervalVal,
                                    [selectedRepeatOption]: value,
                                });
                            }}
                            repeatOption={selectedRepeatOption}
                        ></RepeatInterval>

                        {renderRepeatOption()}

                        <Button
                            variant="secondary"
                            className="mr-2"
                            onClick={backToEventPage}
                        >
                            CANCEL
                        </Button>
                        <Button
                            aria-label="add-update-recurrence-button"
                            variant="primary"
                            className="pl-4 pr-4"
                            onClick={handleAddUpdateCondition}
                        >
                            {params.conditionId ? "UPDATE" : "ADD"}
                        </Button>
                    </Col>
                </Row>
                <DefaultModal
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    modalType={modalType}
                    modalContent={modalContent}
                    okAction={() => {
                        setModalShow(false);
                    }}
                    errorArray={errorArray}
                />
            </Container>
            {modal}
        </ContentWrapper>
    );
};

export default Recurrence;
